import React from 'react';
import ReactApexCharts from 'react-apexcharts';
import PropTypes from 'prop-types';
import { formatNumber } from 'helper';
import { getBaseOptions, getSeries } from './chartTheme';

function LineChart({ data, isLoading }) {
  const base = getBaseOptions();
  const options = {
    ...base,
    colors: getSeries(),
    xaxis: {
      ...base.xaxis,
      categories: data?.map((item, i) => item?.title ?? `Data ${i + 1}`),
    },
    tooltip: {
      ...base.tooltip,
      x: { format: 'dd/MM/yy HH:mm' },
      y: {
        formatter(val) {
          if (!val) return '';
          return formatNumber(val, 0);
        },
      },
    },
    dataLabels: {
      ...base.dataLabels,
      formatter(val) {
        if (!val) return '';
        return formatNumber(val, 0);
      },
    },
  };

  const series = [
    {
      name: 'Total',
      data: data?.map((item) => item?.count ?? null),
    },
  ];
  if (isLoading) {
    return (
      <div className="h-full w-full pl-10 py-8 pr-6">
        <div
          className="animate-pulse bg-neutral-100 h-full w-full rounded"
          style={{
            clipPath:
              'polygon(0 80%, 13% 71%, 25% 55%, 39% 44%, 54% 51%, 66% 46%, 78% 34%, 90% 22%, 100% 33%, 100% 43%, 100% 100%, 0% 100%)',
          }}
        />
      </div>
    );
  }
  return (
    <ReactApexCharts
      height="100%"
      options={options}
      series={series}
      type="area"
    />
  );
}
LineChart.defaultProps = {
  data: {
    labels: [],
    series: [],
  },
  isLoading: false,
};

LineChart.propTypes = {
  data: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
};

export default LineChart;
